/*--using switch--*/
let SERVER_URL: string;
let CLIENT_URL: string

// Prefer explicit environment variables for API/Client host so builds can be
// configured at deploy time (REACT_APP_API_URL, REACT_APP_CLIENT_URL).
// Fall back to the older REACT_APP_ENV switch for environments that don't
// provide explicit URLs.
const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
const REACT_APP_CLIENT_URL = process.env.REACT_APP_CLIENT_URL;
const REACT_APP_ENV = process.env.REACT_APP_ENV || 'dev';

console.log("REACT_APP_ENV=", REACT_APP_ENV);

if ( REACT_APP_API_URL || REACT_APP_CLIENT_URL ) {
    // If explicit URLs are provided, use them (allows CI/RunCloud to inject exact paths).
    SERVER_URL = REACT_APP_API_URL || '';
    CLIENT_URL = REACT_APP_CLIENT_URL || '';
} else {
    switch (REACT_APP_ENV) {
    case 'local':
        SERVER_URL = "http://localhost:2020";
        CLIENT_URL = "http://127.0.0.1:3000";
        break;
    case 'dev':
        SERVER_URL = "http://api.dsba.embold.net";
        CLIENT_URL = "https://admin.dsba.embold.net";
        break;
    case 'qa':
        SERVER_URL = "https://apiqa.apptechware.com";
        CLIENT_URL = "https://adminqa.apptechware.com";
        break;
    case 'prod':
        SERVER_URL = "https://api.dsba.org";
        CLIENT_URL = "https://admin.dsba.org";
        break;
    default:
        SERVER_URL = "http://54.196.200.71/dsba_dev";
        CLIENT_URL = "http://dev.dsba.mavinapps.com/dsba/";
        break;
    }
}

export { SERVER_URL, CLIENT_URL };
